import axios from "axios";
import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FORM_APPOINTMENT_API } from "../../config/constant";
import { toast } from "react-toastify";
import { concat } from "lodash-es";
import { useLocation } from "react-router-dom";

const FormBookAppointment = ({ toptext, btntext, bgcolor }) => {
  const [formappointmentdata, setFormappointmentdata] = useState(null);
  const location = useLocation();
  const { serviceId } = location.state || {};
  console.log("iddddddd", serviceId);

  // Form validation schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    mobile_number: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    address: Yup.string().required("Address is required"),
    service_message: Yup.string().required("Service message is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "",
      mobile_number: "",
      email: "",
      address: "",
      service_message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await axios.post(FORM_APPOINTMENT_API, {
          ...values,
          service_id: serviceId,
        });

        console.log("formappointmentdata==>", response.data);
        setFormappointmentdata(response.data.DATA);
        toast.success("Appointment Form Save Successfully!!!");
        resetForm();
      } catch (err) {
        console.error("Error submitting form:", err);
        toast.error("Appointment Form Not Submitted!!!");
      }
    },
  });

  return (
    <>
      <div className="col-12 col-lg-4 text-start d-flex flex-column">
        <div className="form-section" style={{
          maxWidth: "100%", flex: "none",
        }}>
          <h3>Book Attendant Services at Home With TTHC</h3>
          <form>
            <input type="text" placeholder="Patient Name*" required />
            <input type="tel" placeholder="Mobile Number*" required />
            <input type="email" placeholder="Email Id" />
            <input type="text" placeholder="Address" />
            <input type="text" placeholder="Service Required" />
            <button type="submit" className="book-btn">
              Book an Appointment
            </button>
          </form>
          <p className="disclaimer">
            By submitting the form, you Agree to TTHC
          </p>
        </div>


        {formappointmentdata && (
          <div className="mt-4">
            <h5>Submitted Data:</h5>
            <pre>{JSON.stringify(formappointmentdata, null, 2)}</pre>
          </div>
        )}
      </div >
    </>
  );
};

export default FormBookAppointment;
